export default function (nga, admin) {
	var channels_mapping_report = admin.getEntity('channels_mapping_report');
	channels_mapping_report.listView()
		.title('<h4>Package Channel Mapping <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
		.batchActions([])
		.fields([
			nga.field('combo_name', 'string')
				.label('Plan Name'),
			nga.field('is_active', 'string')
				.map(function (value, entry) {
					if(value == 1){
						return "Active";
					}
					return "In-Active";
				})
				.label('Is Active'),
			nga.field('definition', 'string')
				.map(function (value, entry) {
					if(value == 1){
						return "HD";
					}
					return "SD";
				})
				.label('Definition'),
			nga.field('cas_code', 'string')
				.label('CAS Code'),
			nga.field('channel_name', 'string')
				.label('Channel Name'),
		])
		.exportFields([
			channels_mapping_report.listView().fields(),
        ]);
	return channels_mapping_report;
}



// WEBPACK FOOTER //
// ./js/channelsMappingReport/config.js